const PhotoComponentStyle = (theme) => {
  return {
    photobox: {
      backgroundColor: theme.palette.grey["50"],
      borderRadius: "5px",
      border: `${theme.palette.grey["400"]} solid 2px`,
      textAlign: "center",
    },
  };
};

export default PhotoComponentStyle;
